import { createSelector } from 'reselect'

import { selectUrlState } from 'containers/ResolutionCenter/List/selectors'

import { PLAN_TYPES } from '../App/constants'
import { selectActualLicenses } from '../App/selectors'

import { URL_STATE } from './List/constants'
import {
  EXCLUDING_THEMIS_SPAM_SAFE_OPTION,
  GENERAL_FILTER_OPTIONS,
  GENERAL_FILTER_STARTER_OPTIONS,
} from './constants'

const selectData = (state) => state.resolutioncenter.self.data
const selectLoader = (state) => state.resolutioncenter.self.loader
const selectError = (state) => state.resolutioncenter.self.error
const selectIsDataLoaded = (state) => state.resolutioncenter.self.isDataLoaded

const GENERAL_FILTER_SCANBACK_OPTIONS = Object.freeze(
  GENERAL_FILTER_OPTIONS.concat(EXCLUDING_THEMIS_SPAM_SAFE_OPTION)
)

const selectIsPlanStarter = (state) => selectActualLicenses(state).plan === PLAN_TYPES.STARTER

const selectGeneralFilterOptions = createSelector(
  selectIsPlanStarter,
  selectUrlState,
  (isPlanStarter, urlState) => {
    if (isPlanStarter) return GENERAL_FILTER_STARTER_OPTIONS
    if (urlState === URL_STATE.SCANBACK) return GENERAL_FILTER_SCANBACK_OPTIONS
    return GENERAL_FILTER_OPTIONS
  }
)

export { selectData, selectLoader, selectError, selectIsDataLoaded, selectGeneralFilterOptions }
